import React from "react";

export default function ParagraphIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.18 2.5H16.8C17.1866 2.5 17.5 2.8134 17.5 3.2C17.5 3.5866 17.1866 3.9 16.8 3.9H15.12V16.8C15.12 17.1866 14.8066 17.5 14.42 17.5C14.0334 17.5 13.72 17.1866 13.72 16.8V3.9H12.03V16.8C12.03 17.1866 11.7166 17.5 11.33 17.5C10.9434 17.5 10.63 17.1866 10.63 16.8V12.5H7.18C4.59369 12.4945 2.49999 10.3963 2.5 7.81V7.18C2.5055 4.59759 4.59759 2.5055 7.18 2.5ZM4.86129 10.1258C5.4767 10.7393 6.31101 11.0827 7.17999 11.08H10.63V3.9H7.17999C5.3685 3.9 3.89999 5.36851 3.89999 7.18V7.81C3.89999 8.67899 4.24588 9.51225 4.86129 10.1258Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
